import { render, staticRenderFns } from "./NotifyLastList.vue?vue&type=template&id=2b5ca254&scoped=true&"
import script from "./NotifyLastList.vue?vue&type=script&lang=js&"
export * from "./NotifyLastList.vue?vue&type=script&lang=js&"
import style0 from "./NotifyLastList.vue?vue&type=style&index=0&id=2b5ca254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5ca254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCol,VIcon,VList,VListItem,VListItemAvatar,VListItemContent,VListItemIcon,VListItemTitle,VRow})
